import { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';

const useUsers = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const database = getDatabase();
    const usersRef = ref(database, 'users');

    const unsubscribe = onValue(usersRef, (snapshot) => {
      if (snapshot.exists()) {
        const usersData = snapshot.val();
        const usersList = Object.keys(usersData).map((key) => ({
          id: key,
          ...usersData[key],
        }));
        setUsers(usersList);
      } else {
      }
    }, (error) => {

    });

    return () => unsubscribe();
  }, []);

  const findUserById = (id) => {
    const user = users.find((user) => user.id === id);
    if (user) {
      return {
        name: user.name || `${user.firstName || ''} ${user.lastName || ''}`.trim(),
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        userPhoto: user.userPhoto || user.photoURL || '',
        photoURL: user.photoURL || user.userPhoto || '',
        fullName: user.fullName || '',
        username: user.username || '',
        empID: user.empID || '',
        email: user.email || '',
      };
    }
    return null;
  };

  return { users, findUserById };
};

export default useUsers;